import React from "react";
import { ComposedChart, Line, Area, ReferenceLine, XAxis, YAxis } from 'recharts';


export const SparkLine = (props) => {
	const { data, width, height, showAsArea, showAverageLine, showForecast } = props;

    // Convert string data to JSON array if needed
    let parsedData = data;
    if (typeof data === 'string') {
        try {
            parsedData = JSON.parse(data);
        } catch (e) {
            console.error('Failed to parse data as JSON:', e);
            parsedData = [];
        }
    }

    const _width = width || 100;
    const _height = height ?? 30;
    const dataFound = true;

    let lineData = [];
    let sumValues = 0;
    let averageValue = 0;

    // Check if data contains forecast info (objects with actual/forecast properties)
    const hasForecastData = parsedData && parsedData.length > 0 && 
        typeof parsedData[0] === 'object' && parsedData[0] !== null && 
        ('actual' in parsedData[0] || 'forecast' in parsedData[0]);

    if (parsedData && parsedData.length > 0) {
        if (hasForecastData && showForecast) {
            // Data has actual/forecast structure
            lineData = parsedData.map((x, index) => ({
                actual: x.actual ?? null,
                forecast: x.forecast ?? null,
                value: (x.actual || 0) + (x.forecast || 0), // Combined for area fill
                index: index
            }));
        } else {
            // Simple array of numbers
            lineData = parsedData.map((x, index) => ({value: typeof x === 'object' ? (x.value || x.actual || 0) : x, index: index}));
        }
        sumValues = lineData.reduce((acc, cur) => acc + (cur.value || 0), 0);
        averageValue = sumValues / lineData.length;
        
        if (sumValues > 0) {
            lineData[0]._isFirst = true;
            lineData[lineData.length - 1]._isLast = true;    
        }    
    }

    const CustomizedDot = (props) => {
        const { cx, cy,  payload } = props;
    
        if (payload._isFirst || payload._isLast) {
            return (
                <svg x={cx-2} y={cy-2} width={4} height={4} fill="red">
                    <g transform="translate(4 4)">
                        <circle r="4" fill="hsl(var(--chart-1))" />
                        {/* <circle r="2" fill="white" /> */}
                    </g>
                </svg>
            );
        }
    
        return null;
    };

    // console.log(lineData);
    
	return (
		<div className="w-full">
            {dataFound ? (
                <div className="w-full">
                    <ComposedChart 
                        width={_width} 
                        height={_height} 
                        margin={showAsArea ? {
                            top: 5,
                            left: 0,
                            bottom: 0,
                            right: 0,
                        } : {
                            top: 5,
                            left: 5,
                            bottom: 5,
                            right: 5,
                        }}
                        data={lineData}
                        className="">
                        <XAxis 
                            hide 
                            dataKey="index" 
                            type="number" 
                            domain={[0, lineData.length > 0 ? lineData.length - 1 : 0]}
                            allowDataOverflow={true}
                        />
                        <YAxis hide domain={['dataMin', 'dataMax']} />
                        {lineData.length > 0 && showAverageLine && (
                            <ReferenceLine
                                y={averageValue}
                                stroke="hsl(var(--chart-grid))"
                                strokeWidth={1}
                                strokeDasharray="3 3"
                            />
                        )}
                        {showAsArea ? (
                            <>
                                {/* Area fill for combined actual + forecast */}
                                <Area
                                    type="monotone"
                                    dataKey="value"
                                    stroke="none"
                                    fill="hsl(var(--chart-1))"
                                    fillOpacity={0.3}
                                    dot={false}
                                    isAnimationActive={false}
                                />
                                {/* Actual line - solid blue */}
                                {hasForecastData && showForecast ? (
                                    <>
                                        <Line
                                            type="monotone"
                                            dataKey="actual"
                                            stroke="hsl(var(--chart-1))"
                                            strokeWidth={2}
                                            dot={false}
                                            isAnimationActive={false}
                                            connectNulls={false}
                                        />
                                        {/* Forecast line - dashed red */}
                                        <Line
                                            type="monotone"
                                            dataKey="forecast"
                                            stroke="hsl(var(--chart-pred))"
                                            strokeWidth={2}
                                            strokeDasharray="4 4"
                                            dot={false}
                                            isAnimationActive={false}
                                            connectNulls={false}
                                        />
                                    </>
                                ) : (
                                    <Line
                                        type="monotone"
                                        dataKey="value"
                                        stroke="hsl(var(--chart-1))"
                                        strokeWidth={2}
                                        dot={false}
                                        isAnimationActive={false}
                                    />
                                )}
                            </>
                        ) : (
                            <Line
                                // width="200"
                                // height="20"
                                // cx="50%"
                                // cy="50%"
                                // stroke=""
                                // labelLine={false}
                                // outerRadius={10}
                                // fill="#8884d8"
                                type="monotone"
                                dot={<CustomizedDot />}
                                dataKey="value"
                                isAnimationActive={false}
                                >
                            </Line>
                        )}
                        {/* <Tooltip
                            content={renderTooltip}
                            cursor={{ fill: "#F4F4F4" }}
                            // cursor={{fill: 'transparent'}}
                        /> */}
                    </ComposedChart>
                </div>
            ) : (
                <div></div>
            )}            
		</div>
	);
};




